module.exports = __webpack_public_path__ + "img/f21a43e.svg";